// vendors
// import './global/jquery-3.4.1.min'
// import './global/popper.min'
// import './global/bootstrap.min'


// Jquery - jQuery is a popular and feature-rich JavaScript library. Learn more: https://jquery.com/
window.jQuery = window.$ = require('jquery');

// Bootstrap - The most popular framework that Metronic uses as the foundation. Learn more: http://getbootstrap.com
require('./custom/bootstrap.esm.min');

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
// window.Popper = require('popper.js').default;

// Wnumb - Number & Money formatting. Learn more: https://refreshless.com/wnumb/
window.wNumb = require('wnumb');

// JQuery Mask Plugin - is a jQuery plugin which create an input mask. An input mask helps the user with the input by ensuring a predefined format: https://igorescobar.github.io/jQuery-Mask-Plugin/
require('jquery-mask-plugin');

// jQuery BlockUI - The jQuery BlockUI Plugin lets you simulate synchronous behavior when using AJAX: http://malsup.com/jquery/block/
require('block-ui/jquery.blockUI');

// Clipboard - Copy text to the clipboard shouldn't be hard. It shouldn't require dozens of steps to configure or hundreds of KBs to load: https://clipboardjs.com/
window.ClipboardJS = require('clipboard/dist/clipboard.min');

// Toastr - is a Javascript library for non-blocking notifications. jQuery is required. The goal is to create a simple core library that can be customized and extended: https://github.com/CodeSeven/toastr
window.toastr = require('toastr/build/toastr.min');

// Sweetalert2 - a beautiful, responsive, customizable and accessible (WAI-ARIA) replacement for JavaScript's popup boxes: https://sweetalert2.github.io/
window.Swal = window.swal = require('sweetalert2/dist/sweetalert2');
require('./custom/sweetalert2/sweetalert2.init.js');

window.noUiSlider = require('nouislider/dist/nouislider');

require('es6-promise-polyfill/promise.min');

// 3rd-party

// require('./custom/swiper-bundle.min')

require("bootstrap-slider");

require("jquery-countdown");

// require("@fancyapps/fancybox");

require("jquery-nice-select");

// require("./custom/jquery.horizontalmenu.js")
// require('./custom/ResizeSensor.min.js')
// require('./custom/theia-sticky-sidebar.min.js')
require('./custom/xzoom.min')
// require('./custom/xzoom-setup')

window.FormValidation = require("@mohamadtsn/form-validation/dist/amd/index");
window.FormValidation.plugins.Bootstrap = require("@mohamadtsn/form-validation/dist/amd/plugins/Bootstrap").default;
window.FormValidation.plugins.Icon = require("@mohamadtsn/form-validation/dist/amd/plugins/Icon").default;
window.FormValidation.plugins.AutoFocus = require("@mohamadtsn/form-validation/dist/amd/plugins/AutoFocus").default;
window.FormValidation.locales = require("@mohamadtsn/form-validation/dist/amd/locales/fa_IR").default;

// require('md.bootstrappersiandatetimepicker')
// import 'md.bootstrappersiandatetimepicker/dist/mds.bs.datetimepicker'